<template>
	<div class="content">
		<div class="top">
			<div class="Hotline">
				<img src="https://szj-asset.oss-cn-shenzhen.aliyuncs.com/official/icon/P1.png" >
				<div>服务热线：</div>
				<p>400-162-5566</p>
			</div>
			<div class="friendChain">
				<div v-for="(item,index) in friendChain" :key="index" class="list">
					<p>{{item.name}}</p>
					<span v-for="(item2,index2) in item.list" :key="index2">{{item2.name}}</span>
				</div>
			</div>
			<div class="entrance">
				<div class="neirong">
					<img src="https://szj-asset.oss-cn-shenzhen.aliyuncs.com/official/icon/P7.png" >
					<p>上职家微信小程序</p>
				</div>
				<div class="neirong">
					<img src="https://szj-asset.oss-cn-shenzhen.aliyuncs.com/official/icon/P4.png" >
					<p>上职家微信公众号</p>
				</div>
			</div>
		</div>
		<div class="bottom">
			<div class="text">
				Copyright © 2019-2021 www.shangzhijia.cn 湖南上职家信息科技有限公司 版权所有 <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">湘ICP备20000050号-1</a>
				<img src="https://szj-asset.oss-cn-shenzhen.aliyuncs.com/official/icon/P3.png" >
				<!-- 湘公网安备 XXXXXXXXX号 -->
			</div>
			<!-- <div class="icon">
				<div></div>
				<div></div>
			</div> -->
		</div>
	</div>
</template>

<script>
	export default {
		name: "tail",
		data() {
			return {
				friendChain:[
					{
						name:'快速通道',
						list:[
							{
								name:'上职家',
								url:''
							},
							{
								name:'结贝云',
								url:''
							},
							{
								name:'服务驿站',
								url:''
							}
						]
					},
					{
						name:'服务支持',
						list:[
							{
								name:'服务流程',
								url:''
							},
							{
								name:'安全技术',
								url:''
							},
							{
								name:'常见问题',
								url:''
							}
						]
					},
					{
						name:'业务合作',
						list:[
							{
								name:'渠道合作',
								url:''
							}
						]
					},
					{
						name:'关于我们',
						list:[
							{
								name:'企业介绍',
								url:''
							},
							{
								name:'企业热点',
								url:''
							},
							{
								name:'软件著作',
								url:''
							},
							{
								name:'联系我们',
								url:''
							}
						]
					}
				]
			}
		},
		mounted() {},
		methods:{
			
		}
	}
</script>

<style lang="less" scoped>
	.content{
		.bottom{
			.icon{
				div{
					width: 110px;
					height: 39px;
					background-color: #999999;
					border-radius: 4px;
					margin-right: 20px;
				}
				margin: 18px auto 0;
				display: flex;
				width: 240px;
			}
			.text{
				a{
					color: #c3c3c3;
				}
				img{
					margin-top: -4px;
				}
				text-align: center;
				font-size: 14px;
				color: #999999;
			}
			padding: 29px 0 0;
		}
		.top{
			.entrance{
				.neirong{
					margin-right: 40px;
				}
				img{
					width: 100px;
					height: 100px;
					background-color: #FFFFFF;
					margin-bottom: 13px;
					border-radius: 4px;
				}
				color: #999999;
				font-size: 12px;
				margin-left: 150px;
				display: flex;
			}
			.friendChain{
				.list{
					a,span{
						font-size: 14px;
						color: #999999;
						margin-bottom: 10px;
						// cursor: pointer;
						display: block;
					}
					a:hover{color:#00BCD4;} 
					p{
						font-size: 16px;
						color: #FFFFFF;
						margin-bottom: 20px;
					}
				}
				width: 542px;
				margin-left: 130px;
				display: flex;
				justify-content: space-between;
			}
			.Hotline{
				width: 155px;
				p{
					font-size: 20px;
					font-weight: bold;
					margin-top: 5px;
				}
				img{
					width: 32px;
					height: 38px;
					margin-bottom: 15px;
				}
				font-size: 16px;
				color: #FFFFFF;
			}
			width: 1200px;
			display: flex;
			margin: auto;
			padding-bottom: 40px;
			border-bottom: 1px solid #333333;
		}
		background-color: #272727;
		padding: 59px 0 30px;
	}
</style>
